import { RGBColor } from 'react-color';

export const rgbToString = (rgba: RGBColor, minAlpha = 0.2) =>
  `rgba(${rgba.r},${rgba.g},${rgba.b},${Math.max(
    rgba.a === undefined ? 1 : rgba.a,
    minAlpha
  )})`;
